/* eslint-disable max-statements */
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { apiClient } from '@utils';

interface HookProps {
  date: Date;
}

export const useGenerateBatchesReport = () => {
  const toasterId = toast.info('Generating batches report..', {
    containerId: 'generateBatchesReport',
    autoClose: false,
    closeButton: false,
  });

  return useMutation({
    mutationFn: async ({ date }: HookProps) => {
      const result = await apiClient.declarationsReports.generateBatchesReport.mutation({ body: { date } });
      if (result.status !== 200) throw result.body;

      const blob = result.body as Blob;
      const contentDisposition = result.headers.get('content-disposition') ?? '';
      const reportFilename = /filename="([^"]*)"/.exec(contentDisposition)?.[1] ?? 'intrastat-daily.zip';

      const href = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = href;
      link.setAttribute('download', reportFilename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(href);
    },
    onSuccess: () => {
      toast.update(toasterId, {
        render: 'Successfully generated the batches report!',
        autoClose: 3000,
        closeButton: true,
        type: 'success',
      });
    },
    onError: (error) => {
      toast.update(toasterId, {
        render: `Error generating the batches report!`,
        autoClose: 3000,
        closeButton: true,
        type: 'error',
      });
    },
  });
};
